const chipOutlined: object = {
  "blue-gray": {
    border: "border border-blue-gray-500",
    color: "text-blue-gray-700",
  },
  gray: {
    border: "border border-gray-500",
    color: "text-gray-700",
  },
  brown: {
    border: "border border-brown-500",
    color: "text-brown-700",
  },
  "deep-orange": {
    border: "border border-deep-orange-500",
    color: "text-deep-orange-700",
  },
  orange: {
    border: "border border-orange-500",
    color: "text-orange-700",
  },
  amber: {
    border: "border border-amber-500",
    color: "text-amber-700",
  },
  yellow: {
    border: "border border-yellow-500",
    color: "text-yellow-700",
  },
  lime: {
    border: "border border-lime-500",
    color: "text-lime-700",
  },
  "light-green": {
    border: "border border-light-green-500",
    color: "text-light-green-700",
  },
  green: {
    border: "border border-green-500",
    color: "text-green-700",
  },
  teal: {
    border: "border border-teal-500",
    color: "text-teal-700",
  },
  cyan: {
    border: "border border-cyan-500",
    color: "text-cyan-700",
  },
  "light-blue": {
    border: "border border-light-blue-500",
    color: "text-light-blue-700",
  },
  blue: {
    border: "border border-blue-500",
    color: "text-blue-700",
  },
  indigo: {
    border: "border border-indigo-500",
    color: "text-indigo-700",
  },
  "deep-purple": {
    border: "border border-deep-purple-500",
    color: "text-deep-purple-700",
  },
  purple: {
    border: "border border-purple-500",
    color: "text-purple-700",
  },
  pink: {
    border: "border border-pink-500",
    color: "text-pink-700",
  },
  red: {
    border: "border border-red-500",
    color: "text-red-700",
  },
};

export default chipOutlined;
